import React from 'react';
import TamaraBanner from './components/TamaraBanner';
import useDesignAssets from './hooks/useDesignAssets';

const TestAssetsPage = () => {
  const { testAllAssets, backendUrl } = useDesignAssets();

  const handleTestAssets = async () => {
    console.log('🔍 Testing all assets...');
    const results = await testAllAssets();
    console.table(results);
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-6xl mx-auto space-y-8">
        
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Design Assets Test Page</h1>
          <p className="text-gray-400">Testing robust asset loading with fallbacks</p>
          <p className="text-sm text-gray-500 mt-2">Backend URL: {backendUrl || 'Not configured'}</p>
        </div>

        {/* Test Controls */}
        <div className="bg-gray-800 rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4">🧪 Test Controls</h2>
          <button
            onClick={handleTestAssets}
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded font-medium transition-colors"
          >
            Test All Assets Availability
          </button>
          <p className="text-sm text-gray-400 mt-2">Check browser console for detailed results</p>
        </div>

        {/* Tamara Banner - Different Modes */}
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-bold mb-4">🎨 Tamara Banner - Full Mode</h2>
            <TamaraBanner 
              className="w-full" 
              fallbackMode="full"
              showDownloadButton={true}
              onError={(error) => console.error('Banner error:', error)}
            />
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-4">📱 Tamara Banner - Compact Mode</h2>
            <TamaraBanner 
              className="w-full max-w-2xl mx-auto" 
              fallbackMode="compact"
              showDownloadButton={true}
            />
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-4">⚡ Tamara Banner - Minimal Mode</h2>
            <TamaraBanner 
              className="w-full max-w-md mx-auto" 
              fallbackMode="minimal"
              showDownloadButton={false}
            />
          </div>
        </div>

        {/* Asset URLs Display */}
        <div className="bg-gray-800 rounded-lg p-6">
          <h2 className="text-2xl font-bold mb-4">🔗 Asset URLs</h2>
          <div className="space-y-2 text-sm">
            <div>
              <strong>Banner URL:</strong> 
              <a 
                href={`${backendUrl}/api/design-assets/tamara-banner`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 ml-2"
              >
                {backendUrl}/api/design-assets/tamara-banner
              </a>
            </div>
            <div>
              <strong>Download URL:</strong> 
              <a 
                href={`${backendUrl}/api/design-assets/download/tamara-banner`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 ml-2"
              >
                {backendUrl}/api/design-assets/download/tamara-banner
              </a>
            </div>
            <div>
              <strong>Design Assets Index:</strong> 
              <a 
                href={`${backendUrl}/api/design-assets`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 ml-2"
              >
                {backendUrl}/api/design-assets
              </a>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-blue-900/50 rounded-lg p-6">
          <h2 className="text-xl font-bold mb-4">📋 Test Instructions</h2>
          <ul className="space-y-2 text-sm">
            <li>• The banner should load from the local backend endpoint</li>
            <li>• If the endpoint fails, fallback UI should be shown</li>
            <li>• Download buttons should work correctly</li>
            <li>• Different fallback modes should display appropriately</li>
            <li>• Console should show asset loading status</li>
          </ul>
        </div>

        <div className="text-center pt-8">
          <a 
            href="/"
            className="bg-purple-600 hover:bg-purple-700 px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            ← Back to Main App
          </a>
        </div>

      </div>
    </div>
  );
};

export default TestAssetsPage;